var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningFilled = function SvgWarningFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17,
    fill: "currentColor",
    viewBox: "0 0 19 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17h19L9.5 0Zm10.363-2.684H8.637v-1.789h1.726Zm0-3.578H8.637V7.156h1.726Zm0 0"
  })));
};
export default SvgWarningFilled;